import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService, Patch, GetById, UriBuilderParams } from './base/base-http.service';
import { HttpServiceBundle } from './base/http-service-bundle.service';
import { DrQueryParams, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { CaseSummary } from '@app/shared/models/case-summary';

export class CaseSummaryUriBuilderParams extends UriBuilderParams<CaseSummary> {

    constructor(caseSummary: CaseSummary | string) {
        super(caseSummary);
    }

    public buildUri(): string {
        return `${this.simpleUriBuild(BackendUriUnits.CASES)}/summary`;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaseSummaryService extends BaseHttpService<CaseSummary, CaseSummaryUriBuilderParams>
                                implements GetById<CaseSummary, CaseSummaryUriBuilderParams>, Patch<CaseSummary, CaseSummaryUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(CaseSummary, httpServiceBundle);
    }

    // BASE METHODS ****************************************************************************************

    public getById(uriParams: CaseSummaryUriBuilderParams, params?: DrQueryParams): Observable<CaseSummary> {
        return this.getBaseById(uriParams, params);
    }

    public patch(uriParams: CaseSummaryUriBuilderParams, data: OpData[]): Observable<CaseSummary> {
        return this.patchBase(uriParams, data);
    }

    public patchAndUpdate(uriParams: CaseSummaryUriBuilderParams, toUpdate: CaseSummary, data: OpData[]): Observable<CaseSummary> {
        return this.patchAndUpdateBase(uriParams, toUpdate, data);
    }

}
